export default {
  login: 'Login',
  logout: 'Logout',
  loginRequired: 'Login required',
  dateNotFilled: 'date not indicated',
  save: 'Save',
  cancel: 'Cancel',
  savingError: 'An error occurred while saving: {error}.',
  savingSuccess: 'Data saved!',
  addFile: 'Add file',
  loading: 'Loading...',
  documentTip: `There should be no unnecessary objects in the photo. We recommend using
   Microsoft Lens for scanning with your phone.`,
  ifErrorWhenUploading: {
    message: `If you encounter any errors while uploading documents, please upload them to this {0}.
     Make sure the file name corresponds with the name of the document.`,
    folder: 'the folder',
  },
  privacyPolicy: 'Privacy Notice for Candidates',
};
